window.addEventListener('DOMContentLoaded', function() {
    ( function( $ ) {
    
        var checkViewportWidth = $( document ).viewPortDetect();

        $(document).ready(function(){

            $('.clientItemContainer').masonry({            
                columnWidth: '.gridSizer',            
                gutter: '.gutterSizer',
                itemSelector: '.clientItem',
                percentPosition: true
            });

            $('.tabButton').on('click', function(e){

                var getFilter = $(this).data('filter');
                var aTag = $("a[name='caseResultsAnchor']");
                var tabHeight = $('.tabSelector').height();

                var setScrollTop = (aTag.offset().top - 88 - tabHeight);

                $('html,body').animate({scrollTop: setScrollTop},'slow');

                $.get("/case-studies/index-ajax/b2b/"+getFilter, function(data, status){
                    $('.caseStudyResults').empty().html(data);
                });

            });

            setHeightCarousel();
            setHeightPortfolioSectors();

            $(window).bind('resizeEnd', function () {

                setHeightCarousel();
                setHeightPortfolioSectors();

            }); 

            // Swap the nav elements to alternative 'white' mode.
            if($('.mainNav').hasClass('scrolled')){        
                $('#nav').removeClass('altNav');
                $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
            }else{
                $('#nav').addClass('altNav');
                $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
            }

            $('body').on('click', '.hamburger', function () {

               if($('.mainNav').hasClass('hamburgerActive')){        
                    $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
                }else{
                    if(!$('.mainNav').hasClass('scrolled')){ 
                        $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
                    }
                } 

            });

        });

        $( window ).scroll(function() {

            setTimeout(function(){
                if($('.mainNav').hasClass('scrolled')){        
                    $('#nav').removeClass('altNav');
                    $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
                }else{
                    $('#nav').addClass('altNav');
                    $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
                }
            }, 200);

        });

        function setHeightCarousel(){

            if(checkViewportWidth.detectViewPort() > 767){

                $('.videoContainer').attr('style', '');
                $('.videoCropWrapper').attr('style', '');
                $('.videoHeight').css('height', 'inherit');

                // Add to the height of the videoContainer taking into account the height of the 'heroTitle' incase the text is large.
                var heroTitleHeight = $('.heroTitle').height();
                var currentVideoContainerHeight = $('.videoContainer').height();

                $('.videoContainer').css('height', (heroTitleHeight + currentVideoContainerHeight) + 'px');
                $('.videoCropWrapper').css('height', (heroTitleHeight + currentVideoContainerHeight) + 'px');

                var getVideoContainerHeight = $('.videoContainer').height();

                $('.videoHeight').css('height', '' + (getVideoContainerHeight + 20) + 'px');

            }else{

                $('.videoContainer').attr('style', '');
                $('.videoCropWrapper').attr('style', '');
                $('.videoHeight').css('height', 'inherit');

            }

        }

        function setHeightPortfolioSectors(){

            if(checkViewportWidth.detectViewPort() < 768){
                var heightOffset = 80;
            }else if( (checkViewportWidth.detectViewPort() >= 768) && (checkViewportWidth.detectViewPort() < 1025)){
                var heightOffset = 50;
            }else{
                var heightOffset = 10;
            }

            $('.portfolioInner').css('height', 'inherit');
            $('.portfolioInner').css('padding-top', 0);
            $('.portfolioInner').css('padding-bottom', 0);

            var setHeight = 0;        

            $('.portfolioSector').each(function(){

                if($(this).height() > setHeight){setHeight = $(this).height();}

            });                

            $('.portfolioInner').css('height', (setHeight+heightOffset) + 'px');

            // Now attempt to apply padding on the top to force the content into the middle.
            if(checkViewportWidth.detectViewPort() < 1025){

                $('.portfolioInner').css('padding-top', 0);
                $('.portfolioInner').css('padding-bottom', 0);            

                $('.portfolioSector').each(function(){

                    var setPaddingTop = (( ($(this).height()) - ($(this).find('.portfolioAlignMiddleMobile').height() + 50) ) / 2);// - 5;

                    $(this).find('.portfolioInner').css('padding-top', setPaddingTop + 'px');
                    $(this).find('.portfolioInner').css('padding-bottom', setPaddingTop + 'px');

                });


            }else{

                $('.portfolioInner').css('padding-top', 0);
                $('.portfolioInner').css('padding-bottom', 0);

            }

        }

    } )( jQuery );
});